
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AdminOnboardingAcknowledgmentRequest,
  ProfileWebPreferences,
} from '../models';
import {
    AdminOnboardingAcknowledgmentRequestFromJSON,
    AdminOnboardingAcknowledgmentRequestToJSON,
    ProfileWebPreferencesFromJSON,
    ProfileWebPreferencesToJSON,
} from '../models';

export interface AdminAcknowledgeOnboardingRequest {
    profileId: string;
    adminOnboardingAcknowledgmentRequest: AdminOnboardingAcknowledgmentRequest;
}

export interface GetWebPreferencesRequest {
    accountId: string;
}

/**
 * 
 */
export class WebPreferencesApi extends runtime.BaseAPI {

    /**
     * Acknowledges the portfolio editor product tour for the connected user 
          */
    async acknowledgePortfolioEditorProductTourRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/web-preferences/portfolio-editor-product-tour-acknowledgment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Acknowledges the portfolio editor product tour for the connected user 
          */
    async acknowledgePortfolioEditorProductTour(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.acknowledgePortfolioEditorProductTourRaw(initOverrides);
    }

    /**
     * Acknowledges the portfolio share product tour for the connected user 
          */
    async acknowledgePortfolioShareProductTourRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/web-preferences/portfolio-share-product-tour-acknowledgment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Acknowledges the portfolio share product tour for the connected user 
          */
    async acknowledgePortfolioShareProductTour(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.acknowledgePortfolioShareProductTourRaw(initOverrides);
    }

    /**
     * Acknowledges the profile onboarding for the connected user 
          */
    async acknowledgeProfileOnboardingRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/web-preferences/profile-onboarding-acknowledgment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Acknowledges the profile onboarding for the connected user 
          */
    async acknowledgeProfileOnboarding(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.acknowledgeProfileOnboardingRaw(initOverrides);
    }

    /**
     * Acknowledges the profile product tour for the connected user 
          */
    async acknowledgeProfileProductTourRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/web-preferences/profile-product-tour-acknowledgment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Acknowledges the profile product tour for the connected user 
          */
    async acknowledgeProfileProductTour(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.acknowledgeProfileProductTourRaw(initOverrides);
    }

    /**
     * Admin sets the profile onboarding acknowledgment for a given profile 
          */
    async adminAcknowledgeOnboardingRaw(requestParameters: AdminAcknowledgeOnboardingRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling adminAcknowledgeOnboarding().'
            );
        }

        if (requestParameters['adminOnboardingAcknowledgmentRequest'] == null) {
            throw new runtime.RequiredError(
                'adminOnboardingAcknowledgmentRequest',
                'Required parameter "adminOnboardingAcknowledgmentRequest" was null or undefined when calling adminAcknowledgeOnboarding().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/profile/api/web-preferences/{profileId}/profile-onboarding-acknowledgment`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminOnboardingAcknowledgmentRequestToJSON(requestParameters['adminOnboardingAcknowledgmentRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Admin sets the profile onboarding acknowledgment for a given profile 
          */
    async adminAcknowledgeOnboarding(requestParameters: AdminAcknowledgeOnboardingRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.adminAcknowledgeOnboardingRaw(requestParameters, initOverrides);
    }

    /**
     * Returns the web preferences for current user 
          */
    async getWebPreferencesRaw(requestParameters: GetWebPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProfileWebPreferences>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getWebPreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProfileWebPreferences>({
            path: `/profile/api/web-preferences/{accountId}`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProfileWebPreferencesFromJSON(response._data); }
        return response;
    }

    /**
     * Returns the web preferences for current user 
          */
    async getWebPreferences(requestParameters: GetWebPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProfileWebPreferences> {
        const response = await this.getWebPreferencesRaw(requestParameters, initOverrides);
        return response._data;
    }

}
